import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import { useState } from "react";

import { useId } from "util/html";
import { Row, Column, useMobileScreenClass } from "common/core/responsive";
import { Heading, Paragraph } from "common/core/typography";
import { DisclosureContent, DisclosureToggle } from "common/core/disclosure";
import Link from "common/core/link";

import { SectionContainer } from "../../v3/sections/common";
import CommonStyles from "../common.module.scss";
import Styles from "./index.module.scss";

export default function FrequentlyAskedQuestions() {
  const isMobile = useMobileScreenClass();
  const howItWorksId = useId();
  const whatIsProof = useId();
  const whatIsAProofAccount = useId();
  const [expanded, setExpanded] = useState("");
  const wrapperDivClasses = isMobile ? CommonStyles.columnSmall : CommonStyles.column;

  return (
    <div data-automation-id="faqs" className={classNames(wrapperDivClasses, Styles.faqs)}>
      <SectionContainer>
        <Row>
          <Column>
            <Heading level="h2" textStyle="headingFour" className={Styles.faqTitle}>
              <FormattedMessage
                id="8cfaf202-c566-4ba6-9c9a-10c31ceec54b"
                defaultMessage="Frequently Asked Questions"
              />
            </Heading>

            <div className={Styles.faqListItem}>
              <div className={Styles.faqSubheader}>
                <Paragraph size="large">
                  <FormattedMessage
                    id="cd8a95b6-69ee-41bb-a0c4-19b9f3f27739"
                    defaultMessage="How does this work?"
                  />
                </Paragraph>
                <DisclosureToggle
                  onClick={() => setExpanded(expanded !== howItWorksId ? howItWorksId : "")}
                  expanded={expanded === howItWorksId}
                  controlsId={howItWorksId}
                />
              </div>
              <DisclosureContent expanded={expanded === howItWorksId} id={howItWorksId}>
                <Paragraph>
                  <FormattedMessage
                    id="99dee4d6-b93b-4775-ad5b-5b9f7212d64d"
                    defaultMessage="Signing a document with Proof is easy. Simply click 'Sign now', apply your signature, and download or share your documents."
                  />
                </Paragraph>
              </DisclosureContent>
            </div>

            <div className={Styles.faqListItem}>
              <div className={Styles.faqSubheader}>
                <Paragraph size="large">
                  <FormattedMessage
                    id="56db5c89-b6be-4c7c-bf8c-20481fbcfc81"
                    defaultMessage="What is Proof?"
                  />
                </Paragraph>
                <DisclosureToggle
                  onClick={() => setExpanded(expanded !== whatIsProof ? whatIsProof : "")}
                  expanded={expanded === whatIsProof}
                  controlsId={whatIsProof}
                />
              </div>
              <DisclosureContent expanded={expanded === whatIsProof} id={whatIsProof}>
                <Paragraph>
                  <FormattedMessage
                    id="c2940fd1-840b-4d45-acb8-112d5b4063d4"
                    defaultMessage="Developed by Notarize℠, the experts who brought notarization online, <proof>Proof</proof> is the world’s first identity-assured transaction management platform that verifies identities and secures every transaction to protect your business and your customers. This is the future of trust in the digital world. When risk is low and speed matters, get it signed. When the law dictates it, get it notarized. When trust matters, you need <proof>Proof</proof>."
                    values={{ proof: (text) => <Link href={"https://www.proof.com"}>{text}</Link> }}
                  />
                </Paragraph>
              </DisclosureContent>
            </div>

            <div className={Styles.faqListItem}>
              <div className={Styles.faqSubheader}>
                <Paragraph size="large">
                  <FormattedMessage
                    id="5698b332-9f24-47b8-a53f-95eb11e66a68"
                    defaultMessage="What is a Proof account?"
                  />
                </Paragraph>
                <DisclosureToggle
                  onClick={() =>
                    setExpanded(expanded !== whatIsAProofAccount ? whatIsAProofAccount : "")
                  }
                  expanded={expanded === whatIsAProofAccount}
                  controlsId={whatIsAProofAccount}
                />
              </div>
              <DisclosureContent
                expanded={expanded === whatIsAProofAccount}
                id={whatIsAProofAccount}
              >
                <Paragraph>
                  <FormattedMessage
                    id="b2998c8b-71df-4eef-b3b5-343a21b91c04"
                    defaultMessage="In June of 2023, we <blog>announced</blog> Proof: the next era of Notarize and a natural evolution of what we’ve been working to accomplish over the past eight years. Proof is now our company and our platform — through which you’ll be able to access Notarize as one of our offerings. In other words, <proof>Proof</proof> is everything you already know and love about the Notarize platform, but even better."
                    values={{
                      blog: (text) => (
                        <Link href={"https://www.proof.com/blog/meet-proof"}>{text}</Link>
                      ),
                      proof: (text) => <Link href={"https://www.proof.com"}>{text}</Link>,
                    }}
                  />
                </Paragraph>
              </DisclosureContent>
            </div>
          </Column>
        </Row>
      </SectionContainer>
    </div>
  );
}
